import { render, staticRenderFns } from "./TrancheMarket.vue?vue&type=template&id=dc15313c&scoped=true&"
import script from "./TrancheMarket.vue?vue&type=script&lang=js&"
export * from "./TrancheMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc15313c",
  null
  
)

export default component.exports